module.exports = __webpack_public_path__ + "static/img/icon_ziyingwangyuan@2x.1efc00cf.png";